"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StringBuffer = _interopRequireDefault(require("../../../../java/lang/StringBuffer"));

var _Location = _interopRequireDefault(require("../geom/Location"));

var _Position = _interopRequireDefault(require("./Position"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TopologyLocation =
/*#__PURE__*/
function () {
  function TopologyLocation() {
    _classCallCheck(this, TopologyLocation);

    TopologyLocation.constructor_.apply(this, arguments);
  }

  _createClass(TopologyLocation, [{
    key: "setAllLocations",
    value: function setAllLocations(locValue) {
      for (var i = 0; i < this.location.length; i++) {
        this.location[i] = locValue;
      }
    }
  }, {
    key: "isNull",
    value: function isNull() {
      for (var i = 0; i < this.location.length; i++) {
        if (this.location[i] !== _Location.default.NONE) return false;
      }

      return true;
    }
  }, {
    key: "setAllLocationsIfNull",
    value: function setAllLocationsIfNull(locValue) {
      for (var i = 0; i < this.location.length; i++) {
        if (this.location[i] === _Location.default.NONE) this.location[i] = locValue;
      }
    }
  }, {
    key: "isLine",
    value: function isLine() {
      return this.location.length === 1;
    }
  }, {
    key: "merge",
    value: function merge(gl) {
      if (gl.location.length > this.location.length) {
        var newLoc = new Array(3).fill(null);
        newLoc[_Position.default.ON] = this.location[_Position.default.ON];
        newLoc[_Position.default.LEFT] = _Location.default.NONE;
        newLoc[_Position.default.RIGHT] = _Location.default.NONE;
        this.location = newLoc;
      }

      for (var i = 0; i < this.location.length; i++) {
        if (this.location[i] === _Location.default.NONE && i < gl.location.length) this.location[i] = gl.location[i];
      }
    }
  }, {
    key: "getLocations",
    value: function getLocations() {
      return this.location;
    }
  }, {
    key: "flip",
    value: function flip() {
      if (this.location.length <= 1) return null;
      var temp = this.location[_Position.default.LEFT];
      this.location[_Position.default.LEFT] = this.location[_Position.default.RIGHT];
      this.location[_Position.default.RIGHT] = temp;
    }
  }, {
    key: "toString",
    value: function toString() {
      var buf = new _StringBuffer.default();
      if (this.location.length > 1) buf.append(_Location.default.toLocationSymbol(this.location[_Position.default.LEFT]));
      buf.append(_Location.default.toLocationSymbol(this.location[_Position.default.ON]));
      if (this.location.length > 1) buf.append(_Location.default.toLocationSymbol(this.location[_Position.default.RIGHT]));
      return buf.toString();
    }
  }, {
    key: "setLocations",
    value: function setLocations(on, left, right) {
      this.location[_Position.default.ON] = on;
      this.location[_Position.default.LEFT] = left;
      this.location[_Position.default.RIGHT] = right;
    }
  }, {
    key: "get",
    value: function get(posIndex) {
      if (posIndex < this.location.length) return this.location[posIndex];
      return _Location.default.NONE;
    }
  }, {
    key: "isArea",
    value: function isArea() {
      return this.location.length > 1;
    }
  }, {
    key: "isAnyNull",
    value: function isAnyNull() {
      for (var i = 0; i < this.location.length; i++) {
        if (this.location[i] === _Location.default.NONE) return true;
      }

      return false;
    }
  }, {
    key: "setLocation",
    value: function setLocation() {
      if (arguments.length === 1) {
        var locValue = arguments[0];
        this.setLocation(_Position.default.ON, locValue);
      } else if (arguments.length === 2) {
        var locIndex = arguments[0],
            _locValue = arguments[1];
        this.location[locIndex] = _locValue;
      }
    }
  }, {
    key: "init",
    value: function init(size) {
      this.location = new Array(size).fill(null);
      this.setAllLocations(_Location.default.NONE);
    }
  }, {
    key: "isEqualOnSide",
    value: function isEqualOnSide(le, locIndex) {
      return this.location[locIndex] === le.location[locIndex];
    }
  }, {
    key: "allPositionsEqual",
    value: function allPositionsEqual(loc) {
      for (var i = 0; i < this.location.length; i++) {
        if (this.location[i] !== loc) return false;
      }

      return true;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return TopologyLocation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return TopologyLocation;
}();

exports.default = TopologyLocation;

TopologyLocation.constructor_ = function () {
  this.location = null;

  if (arguments.length === 1) {
    if (arguments[0] instanceof Array) {
      var location = arguments[0];
      this.init(location.length);
    } else if (Number.isInteger(arguments[0])) {
      var on = arguments[0];
      this.init(1);
      this.location[_Position.default.ON] = on;
    } else if (arguments[0] instanceof TopologyLocation) {
      var gl = arguments[0];
      this.init(gl.location.length);

      if (gl !== null) {
        for (var i = 0; i < this.location.length; i++) {
          this.location[i] = gl.location[i];
        }
      }
    }
  } else if (arguments.length === 3) {
    var _on = arguments[0],
        left = arguments[1],
        right = arguments[2];
    this.init(3);
    this.location[_Position.default.ON] = _on;
    this.location[_Position.default.LEFT] = left;
    this.location[_Position.default.RIGHT] = right;
  }
};